export default __webpack_public_path__ + "static/media/27t.65c0baaf.jpg";